<template>
  <div class="wrapper" v-if="$store.state.showHeader">
    <div style="background-color: #f9fbfe;">
      <div class="header_box">
        <div class="header_left">
          <el-dropdown
            placement="top"
            v-if="token"
            trigger="click"
            @command="handleCommand2"
          >
            <span class="welcome-text">
              欢迎您，{{ userInfo.nickname }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <div class="user-info">
                <div class="user-avatar">
                  <img src="@/assets/img/defuser.png" alt="" />
                </div>
                <div class="user-details">
                  <div class="username">{{ userInfo.nickname }}</div>
                  <div class="user-id">{{ userInfo.telephone }}</div>
                </div>
              </div>
              <el-dropdown-item
                v-if="userInfo.isRealAuth != 1"
                command="certification"
                class="cert-btn"
              >
                <el-button
                  style="background-color: #3b75dd;"
                  type="primary"
                  round
                  size="small"
                >
                  去实名认证 <i class="el-icon-arrow-right"></i>
                </el-button>
              </el-dropdown-item>
              <div v-else class="Namedentity">
                <div>企业已实名</div>
              </div>
              <div class="user-dropdown-item">
                <el-dropdown-item command="modifyPassword"
                  >修改密码</el-dropdown-item
                >
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-else
            >欢迎您，<span class="login" @click="toLogin()">登录</span>或<span
              class="login"
              @click="toRegister()"
              >轻松注册</span
            ></span
          >
        </div>
        <div class="header_right">
          <span @click="goTradersCenter" style="margin-right: 40px;"
            >贸易商中心</span
          ><span @click="toPage('About')">关于我们</span>
        </div>
      </div>
    </div>

    <div class="searchBox">
      <div class="searchWrap">
        <div class="logoBox" @click="toHome">
          <img src="@/assets/logo.png" alt="" />
          <div class="logoText">
            <div>欢迎登录融鑫通贸易商平台</div>
            <div>专业的大宗贸易供应链金融平台</div>
          </div>
        </div>
        <div class="search">
          <div class="searchBar-row">
            <div class="searchBar-pill">
              <el-dropdown trigger="click" @command="onSearchCategory">
                <span class="searchBar-category">
                  {{ searchCategoryLabel }}
                  <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in searchCategoryOptions"
                    :key="item.command"
                    :command="item.command"
                  >
                    {{ item.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="searchBar-sep"></span>
              <input
                class="searchBar-input"
                type="text"
                placeholder="请输入招采标题/求购标题"
                v-model="searchContent"
                @focus="searchShow = true"
                @keyup.enter="toSearch({ keywords: searchContent })"
              />
            </div>
            <button
              type="button"
              class="searchBar-btn"
              @click="toSearch({ keywords: searchContent })"
            >
              <img
                src="@/assets/img/search.png"
                alt=""
                class="searchBar-icon"
              />
              <span>搜索</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      style="background-color: #f9fbfe;"
      v-if="routerName !== 'ProcurementDetail' && $route.name !== 'BuyDetail'"
    >
      <div class="headerTab">
        <div class="headerTabLeft">
          <div
            :class="['headerTabItem', { active: $route.name === 'Home' }]"
            @click="toPage('Home')"
          >
            首页
          </div>
          <div
            :class="[
              'headerTabItem',
              { active: $route.name === 'Procurement' },
            ]"
            @click="toPage('Procurement')"
          >
            招采中心
          </div>
          <div
            :class="['headerTabItem', { active: $route.name === 'WantBuy' }]"
            @click="toPage('WantBuy')"
          >
            求购中心
          </div>
          <div
            :class="[
              'headerTabItem',
              {
                active: $route.name === 'Info' || $route.name === 'InfoDetail',
              },
            ]"
            @click="toPage('Info')"
          >
            信息中心
          </div>
          <div
            :class="['headerTabItem', { active: $route.name === 'Finance' }]"
            @click="toPage('Finance')"
          >
            金融中心
          </div>
          <div
            :class="['headerTabItem', { active: $route.name === 'About' }]"
            @click="toPage('About')"
          >
            关于融鑫通
          </div>
        </div>
        <!-- <div class="headerTabRight">
          <img src="@/assets/img/enter.png" alt="" />
          <div>
            立即入住
          </div>
        </div> -->
      </div>
    </div>
    <!-- 实名认证组件 -->
    <RealNameCertification
      :visible.sync="$store.state.certVisible"
      @success="onCertSuccess"
      :style="{
        '--bg-image': `url(${require('@/assets/img/authenticationBg.png')})`,
      }"
    />
  </div>
</template>
<script>
import { getStore, setStore, logoutClear } from "@/utils/auth";
import { userInfo as fetchUserInfo } from "@/api/login";
import RealNameCertification from "@/components/RealNameCertification";
// import StTabNotice from "@/layout/tabNotice";
export default {
  components: { RealNameCertification },
  data() {
    return {
      loginStatus: false,
      userInfo: getStore("userInfo") ? JSON.parse(getStore("userInfo")) : "",
      sticky: false,
      token: getStore("token"),
      searchContent: "",
      /** 当前选中的分类 command，与 searchCategoryOptions 中某项对应 */
      searchCategory: "procurement",
      /** 下拉项：选中后标题 = 对应 label */
      searchCategoryOptions: [
        { command: "procurement", label: "招采信息" },
        { command: "wantBuy", label: "求购信息" },
      ],
      command: {},
      searchShow: false,
    };
  },
  computed: {
    /** 展示为当前选中的分类标题 */
    searchCategoryLabel() {
      const o = this.searchCategoryOptions.find(
        (x) => x.command === this.searchCategory
      );
      return o ? o.label : "";
    },
  },
  watch: {
    $route() {
      this.changeShowState();
    },
  },
  mounted() {
    this.changeShowState();
    if (!this.$common.isEmpty(this.$route.query.searchContent)) {
      console.log(this.$route.query.searchContent);
      this.searchContent = this.$route.query.searchContent;
    }
  },
  methods: {
    // 跳转首页
    toHome() {
      this.$router.push("/");
    },
    changeShowState() {
      let showState = this.$route.meta.showHeader ? true : false;
      this.$store.commit("changeshowHeaderState", showState);
    },
    toLogin() {
      this.$router.push("/login");
    },
    toRegister() {
      this.$router.push("/register");
    },
    handleCommand2(command) {
      switch (command) {
        case "logout":
          logoutClear();
          this.$router.push("/login");
          this.$message({
            message: "退出登录",
            type: "success",
          });
          break;
        case "modifyPassword":
          logoutClear();
          this.$router.push("/forgot-password");
          break;
        case "certification":
          this.changeAuthVisible(true);
          break;
        default:
          break;
      }
    },
    toSearch(item) {
      if (!this.$common.isEmpty(item)) {
        this.searchContent = item.keywords;
      }
      this.$router.push({
        path: "/search",
        query: {
          searchContent: this.searchContent,
          searchType: this.searchCategory,
        },
      });
      this.searchShow = false;
    },
    onSearchCategory(cmd) {
      const hit = this.searchCategoryOptions.some((x) => x.command === cmd);
      if (hit) {
        this.searchCategory = cmd;
      }
    },
    toPage(name) {
      if (name === "Home") {
        this.$router.push("/");
      } else {
        this.$router.push({ name });
      }
    },
    // 刷新用户信息并存入 localStorage
    async refreshUserInfo() {
      try {
        const res = await fetchUserInfo();
        if (res && res.data) {
          setStore("userInfo", res.data);
          this.userInfo = res.data;
        }
      } catch (error) {
        console.error("获取用户信息失败:", error);
      }
    },
    // 去往贸易商中心
    async goTradersCenter() {
      if (!this.token) {
        this.$router.push("/login");
        return;
      }
      await this.refreshUserInfo();
      if (this.userInfo.isRealAuth != 1) {
        this.changeAuthVisible(true);
        return;
      }
      this.$router.push("/tradersCenter");
    },
    // 实名认证成功回调
    async onCertSuccess() {
      await this.refreshUserInfo();
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
.wrapper {
  .noData {
    img {
      width: 50px;
      height: auto;
    }
  }
  width: 100vw;
  min-width: @commentWidth;
  background: #ffffff;
  font-family: PingFang;
  .header_box {
    width: @defaultWidth;
    margin: 0 auto;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: row wrap;
    padding: 10px 0;
    .header_left {
      .welcome-text {
        color: #666;
        font-size: 14px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        padding: 4px 8px;
        border-radius: 4px;

        &:hover {
          color: #3b75dd;
        }

        .el-icon--right {
          margin-left: 4px;
          font-size: 12px;
          color: #3b75dd;
        }
      }
      span {
        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
    }
    .header_right {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      cursor: pointer;
    }
    .active {
      color: #ffffff;
      background: linear-gradient(90deg, #2da9ff 0%, #2976ff 100%);
    }
    .login {
      color: #007eef;
      cursor: pointer;
    }
  }
  .searchBox {
    width: 100%;
    .searchWrap {
      width: @defaultWidth;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 0;
      .logoBox {
        display: flex;
        align-items: center;
        min-width: 110px;
        cursor: pointer;
        img {
          width: 50px;
          height: 50px;
          margin-right: 12px;
          border-radius: 7px;
        }
        .logoText {
          display: flex;
          flex-direction: column;
          gap: 12px;
          flex-shrink: 0;
          :first-child {
            font-size: 18px;
            font-weight: 500;
            color: #333333;
          }
          :last-child {
            font-size: 14px;
            font-weight: 400;
            color: #666666;
          }
        }
      }
      .search {
        width: 45%;
        min-width: 0;
        position: relative;
        .searchBar-row {
          display: flex;
          align-items: stretch;
          justify-content: flex-end;
          width: 100%;
          gap: 10px;
        }
        .searchBar-pill {
          flex: 0 0 408px;
          width: 408px;
          max-width: 100%;
          display: flex;
          align-items: stretch;
          height: 46px;
          background: #f5f8fd;
          border: none;
          border-radius: 999px;
          overflow: hidden;
          box-sizing: border-box;
          /deep/ .el-dropdown {
            display: flex;
            align-items: center;
          }
        }
        .searchBar-category {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 0 16px 0 20px;
          font-size: 14px;
          color: #303133;
          cursor: pointer;
          user-select: none;
          .el-icon-arrow-down {
            font-size: 12px;
            color: #909399;
          }
        }
        .searchBar-sep {
          flex-shrink: 0;
          width: 1px;
          align-self: stretch;
          margin: 10px 0;
          background: #dcdfe6;
        }
        .searchBar-input {
          flex: 1;
          min-width: 0;
          border: none;
          outline: none;
          background: transparent;
          padding: 0 14px;
          font-size: 14px;
          color: #303133;
          &::placeholder {
            color: #c0c4cc;
          }
        }
        .searchBar-btn {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          height: 46px;
          padding: 0 22px;
          margin: 0;
          border: none;
          border-radius: 999px;
          background: #3b75dd;
          color: #ffffff;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
          box-sizing: border-box;
          &:hover {
            background: #2563eb;
          }
        }
        .searchBar-icon {
          width: 18px;
          height: 18px;
          display: block;
          object-fit: contain;
        }
        .show {
          position: absolute;
          top: 55px;
          padding: 10px 20px;
          z-index: 99;
          width: 471px;
          min-height: 90px;
          background: #ffffff;
          box-shadow: 0px 2px 23px -5px rgba(176, 176, 176, 0.35);
          border-radius: 2px;
          div {
            font-size: 14px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #181818;
            line-height: 20px;
            margin-bottom: 8px;
          }
          span {
            padding: 6px 10px;
            border-radius: 2px;
            border: 1px solid #e7e7e7;
            margin: 5px 10px 5px 0;
            font-size: 12px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: #181818;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
          }
          span:hover {
            color: #2c97ff;
            border: 1px solid #2c97ff;
          }
        }
      }
    }
  }

  .headerTab {
    width: @defaultWidth;
    margin: 0 auto;
    background-color: #f9fbfe;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .headerTabLeft {
      display: flex;
      align-items: center;
      gap: 90px;
    }
    .headerTabItem {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      cursor: pointer;
      &:hover {
        color: #3b75dd;
      }
      &.is-active {
        color: #3b75dd;
        font-weight: 600;
      }
      &.active {
        color: #3b75dd;
        font-weight: 600;
      }
    }
  }
  .headerTabRight {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 500;
    color: #3b75dd;
    cursor: pointer;
    border: 1px solid #3b75dd;
    border-radius: 19px 19px 19px 19px;
    padding: 8px 12px;
    img {
      width: 22px;
      height: 22px;
    }
  }
}
</style>

<style lang="less" scoped>
.user-dropdown {
  width: 240px;
  .user-info {
    display: flex;
    align-items: center;
    padding: 0 16px 12px;

    .user-avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 12px;
      background: #f0f0f0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .user-details {
      .username {
        font-size: 16px;
        color: #333333;
        margin-bottom: 4px;
      }

      .user-id {
        font-size: 16px;
        color: #333;
        font-weight: 500;
      }
    }
  }

  .cert-btn {
    padding: 12px 16px;
    .el-button {
      width: 100%;
    }
  }
  .Namedentity {
    padding: 12px 16px;
    div {
      border-radius: 70px;
      padding: 9px 15px;
      font-size: 12px;
      text-align: center;
      color: #3b75dd;
      border: 1px solid #3b75dd;
    }
  }
  .el-dropdown-menu__item {
    padding: 10px 16px;
    color: #3b75dd;
    flex: 1;
    text-align: center;
  }

  .user-dropdown-item {
    display: flex;
    align-items: center;
    border-top: 1px solid #f0f0f0;
  }
}
.el-dropdown-menu {
  padding: 12px 0 0 0;
  margin: 5px 0 0 0;
}
</style>
